/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  apiUtils.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date			  : Sep 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 30, 2019
 * Description   : ASDS-1419
 * 
 * By            : Madhu Gali - H175591
 * On            : Jan 10, 2019
 * Description   : ASDS-2152
 * 
 * By            : Madhu Gali - H175591
 * On            : Jan 14, 2019
 * Description   : ASDS-1765
 * 
 * By            : Suresh Jaladi - E807958
 * On            : Mar 11, 2020
 * Description   : ASDS-1766
 * 
 * By           : H224423
 * On           : 02 Apr, 2020
 * Description  : ASDS-2190 - New Address API error handling.

 ******************************************************************************/

import { logInfo, logError } from '../../../utils/console-utility';
import { handleUnauthorizedUser } from '../../../utils/util';
import UnauthorizedError from 'modules/UnauthorizedError';

/**
 * @description This handles response received from web service calls
 * @param response 
 */
export function handleResponse(response) {
  logInfo('response ', response);
  if (response) {
    if (response.status === 200) {
      return response.data;
    }

    if (response.status === 400 || response.status === 500) {
      const error = response.data.results;
      throw new Error(error);
    }
  }
  throw new Error("Network response was not ok.");
}

/**
 * @description This handles error cases received from web service calls
 * @param response 
 */
export function handleError(error) {
  logError('API call failed. ' + error);
  if (error.response && error.response.status === 401) {
    handleUnauthorizedUser();
    throw new UnauthorizedError('Invalid access token');
  } else {
    throw new Error(error);
  }
}

/**
 * @description This handles unauthorized user error cases received from web service calls
 * @param response 
 */
export function checkUnauthorizedUserError(error: any, message: string) {
  logError(message, error);
  if (error.response && error.response.status === 401) {
    handleUnauthorizedUser();
    throw new UnauthorizedError('Invalid access token');
  }
}
